import { DownloadIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { saveAs } from "file-saver";
import React from "react";
import Api from "../../services/api";

interface DownloadCaskProofButtonProps {
  caskId: number;
  language: "sv" | "en";
}
const getProofFile = async (caskId: number, language: "sv" | "en") => {
  let response = await Api.get(
    `admin/caskproof/${caskId}`,
    true,
    {},
    {
      language,
      timeZone: "Europe/Stockholm",
    }
  );

  let buffer = await response.arrayBuffer();
  var file = new Blob([buffer], { type: "application/pdf" });

  saveAs(file, language === "sv" ? "fatägarbevis.pdf" : "cask-owner-proof.pdf");
};

const DownloadCaskProofButton: React.FC<DownloadCaskProofButtonProps> = ({
  caskId,
  language,
}) => {
  return (
    <>
      <Button
        bg="white"
        leftIcon={<DownloadIcon />}
        variant="outline"
        onClick={async () => await getProofFile(caskId, language)}
      >
        {language.toLocaleUpperCase()}
      </Button>
    </>
  );
};

export default DownloadCaskProofButton;
